import { FC, ReactNode, useEffect, useState } from "react";
import { AnimatePresence, motion, easeInOut } from "framer-motion";
import { texts } from "../../components/locale";

import { ReadMoreButton, StyledDetails, Toggle } from "./styled";

type Props = {
  children: ReactNode | ReactNode[];
  className?: string;
  onToggle?: (isOpen: boolean) => void;
  posterImage?: string;
};

export const ReadMore: FC<Props> = ({ children, className = "", onToggle }) => {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (onToggle) {
      onToggle(isOpen);
    }
  }, [isOpen]);

  return (
    <StyledDetails className={className}>
      <Toggle>
        <ReadMoreButton onClick={() => setOpen((v) => !v)}>
          {isOpen ? texts.read_less : texts.read_more}
        </ReadMoreButton>
      </Toggle>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            exit={{
              height: 0,
              opacity: 0,
              transition: {
                height: {
                  type: "tween",
                  duration: 0.3,
                  delay: 0.3,
                  ease: easeInOut,
                },
              },
            }}
            animate={{
              height: "auto",
              opacity: 1,
            }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </StyledDetails>
  );
};
